import styles from './css/support.module.css'

export default function Support(props) {

  return (
    <div className={styles.body}>
        <address>
            <a href="https://knowledgeforesight.com/">株式会社ナレッジフォーサイト</a><br />
            mail:<a href="mailto:support@knowledgeforsight.com">support@knowledgeforsight.com</a><br />
            tel :<a href="tel:0357292838">03-5729-2838</a><br />
        </address>
    </div>
  )
};